import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=654312ed&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654312ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('654312ed')) {
      api.createRecord('654312ed', component.options)
    } else {
      api.reload('654312ed', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=654312ed&scoped=true&", function () {
      api.rerender('654312ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yPugGVzlGShS/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports